import { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

export const ArrivalDetailsHeader: FunctionComponent<{ inputRequired?: boolean | undefined }> = ({
    inputRequired = false,
}) => {
    return (
        <span className={inputRequired ? 'text-color-primary' : 'text-color-default'}>
            <span className="rioglyph rioglyph-load text-size-18 padding-right-5" />
            <FormattedMessage id="outboundOrderBook.compoundManagement.sidebar.details.arrival" />
        </span>
    );
};

export const NoArrivalDetailsHeader: FunctionComponent = () => (
    <span className="text-color-gray">
        <span className="rioglyph rioglyph-load text-size-18 padding-right-5" />
        <FormattedMessage id="outboundOrderBook.compoundManagement.sidebar.details.arrival" />
        {': '}
        <FormattedMessage id="outboundOrderBook.common.noData" />
    </span>
);
